import React from 'react'
import Cookies from 'universal-cookie'
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri';
function CerrarSesion() {
  
  const cookie = new Cookies()

  const cerrarSecion=()=>{
    cookie.remove("idUsuario",{ path: "/" })
    cookie.remove("tipo",{ path: "/" })
    cookie.remove("correo",{ path: "/" })
    cookie.remove("nombreUsuario",{ path: "/" })
    cookie.remove("ID",{ path: "/" })
    window.location.href="/"
   
    }
  return (
    <button  className="btn btn-secondary" onClick={cerrarSecion} >Cerrar Sesion  <IoIcons.IoMdPower /></button>
  )
}
export default  CerrarSesion;